/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "240")


  
    
export interface API34034Item {
  
  /** 项目ID，应与用户中心project-id相同，做授权和数据脱敏用 */
  projectId?: string;
  
  /** 项目名称 */
  projectName?: string;
  
  /** 任务ID */
  taskId?: string;
  
  /** 导出记录ID */
  recordingId?: string;
  
  /** 文件名 */
  fileName?: string;
  
  /** 导出用户ID */
  doExportUserId?: string;
  
  /** 导出用户名 */
  doExportUserName?: string;
  
  /** 导出开始时间 */
  startTime?: any;
  
  /** 导出结束时间 */
  endTime?: any;
  
  /** 进度百分比 */
  processPercent?: string;
  
  /** 导出显示状态,@seeShowExportStatusEnum */
  showExportStatus?: string;
  
  /** 导出状态显示文案 */
  exportStatusStr?: string;
  
  /** 下载地址 */
  downloadUrl?: string;
  
  /** 菜单名称 */
  menuName?: string;
  
  /** 是否脱敏 */
  isSensitive?: boolean;
  
};
    
  



export interface API34034Req {
  
  /** 项目ID，应与用户中心project-id相同，做授权和数据脱敏用 */
  projectId?: string;
    
  /** 任务ID */
  taskId?: string;
    
  /** 文件名 */
  fileName?: string;
    
  /** 导出用户ID */
  doExportUserId?: string;
    
  /** 导出状态,@deprecated使用showExportStatus代替 */
  exportStatus?: string;
    
  /** 展示用的导出状态：EXPORTING-导出中，DONE-导出成功，STOPPED-导出停止 */
  showExportStatus?: string;
    
  /** 是否脱敏：true-脱敏，false-不脱敏 */
  isSensitive?: string;
    
  /** 创建时间范围--开始 */
  createdAtStart?: string;
    
  /** 创建时间范围--结束 */
  createdAtEnd?: string;
    
  /** 完成时间范围--开始 */
  finishedAtStart?: string;
    
  /** 完成时间范围--结束 */
  finishedAtEnd?: string;
    
  /** 一级菜单ID */
  menuId?: string;
    
  /**  */
  userId?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API34034Res {
  /** T  */
  list?: API34034Item[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 34034  dev_v1.3.0_do导出列表查询

export interface IUseGetAPI34034Return {
  /**  dev_v1.3.0_do导出列表查询: 接口请求状态 */
  isAPI34034Loading: boolean;
  /**  dev_v1.3.0_do导出列表查询: 接口请求返回数据 */
  dataAPI34034: API34034Res;
  /**   dev_v1.3.0_do导出列表查询: 接口数据请求方法 */
  fetchAPI34034Data:  (inputs: API34034Req, config?: YWRequestConfig) => Promise<API34034Res>;
  /**  dev_v1.3.0_do导出列表查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI34034 = ():IUseGetAPI34034Return => {
  let isMount = true;
  const [isAPI34034Loading, setIsAPI34034Loading] = useState(false);
  const [dataAPI34034, setDataAPI34034] = useState<API34034Res>({} as API34034Res);
  const requestUrl = `${basePath}/ywwl-upload-export/export/task/queryExportList`;

  const fetchAPI34034Data = async (inputs: API34034Req, config?: YWRequestConfig): Promise<API34034Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API34034Req>) || {}) as API34034Req;
    
  
    if ( isMount ) {
      setIsAPI34034Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API34034Res>(`${basePath}/ywwl-upload-export/export/task/queryExportList?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI34034(res || {} as API34034Res);
        setIsAPI34034Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI34034Loading(false);
      }
      return false as unknown as API34034Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI34034Loading,
    dataAPI34034,
    fetchAPI34034Data,
    requestUrl,
  }
}

